module.exports = __webpack_public_path__ + "img/ushuaia.63728164.jpg";